module.exports = __webpack_public_path__ + "img/voltaren_arthritis_pain_topical_gel.1012a334.jpeg";